var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-jumbotron',{attrs:{"header":_vm.$t('not_found.title'),"lead":_vm.$t('not_found.message')}},[_c('b-button',{attrs:{"to":{name: 'Home'}}},[_vm._v(_vm._s(_vm.$t('not_found.home_button')))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }